import millisec from 'millisec';
import moment from 'moment-timezone';
import { ABBREV_DECIMALS, DEFAULT_DATETIME_FORMAT, NO_DURATION } from './constants';
export var abbrevNumber = function (num, decimals) {
    if (decimals === void 0) { decimals = ABBREV_DECIMALS; }
    var n = Math.abs(num);
    var sign = Math.sign(num);
    var dec = Math.pow(10, decimals);
    var abbrev = ['k', 'M', 'G'];
    for (var i = abbrev.length - 1; i >= 0; i -= 1) {
        var size = Math.pow(10, ((i + 1) * 3));
        if (size <= n) {
            n = Math.round((n * dec) / size) / dec;
            if ((n === 1000) && (i < abbrev.length - 1)) {
                n = 1;
                i += 1;
            }
            return "" + sign * n + abbrev[i];
        }
    }
    return sign * n;
};
export var abbrevNumberMaxLength = function (num, maxLength) {
    if (maxLength === void 0) { maxLength = 4; }
    var decimals = maxLength;
    var result = abbrevNumber(num, decimals);
    do {
        result = abbrevNumber(num, --decimals);
    } while (result.toString().length > maxLength && decimals > 0);
    return result;
};
export var twoDigits = function (n) { return (n > 9 ? "" + n : "0" + n); };
/**
 * @param time String which represents duration of an operation in 'HH:MM:SS' format
 * @returns {string} Time in milliseconds
 */
export var durationToMilliseconds = function (time) {
    var hoursMinutesSeconds = time.split(':');
    var milliseconds = (parseInt(hoursMinutesSeconds[0], 10) * 3600 + parseInt(hoursMinutesSeconds[1], 10) * 60 + parseInt(hoursMinutesSeconds[2], 10)) * 1000;
    return milliseconds + '';
};
export var millisecondToDuration = function (milliseconds) {
    var ms = milliseconds;
    if (ms === null || ms === undefined) {
        return NO_DURATION;
    }
    if (ms > 0 && ms < 1000) {
        ms = 1000;
    }
    var sec = millisec(ms).format('ss');
    var min = millisec(ms).format('mm');
    var hours = millisec(ms).format('hhh');
    return twoDigits(hours) + ":" + twoDigits(min) + ":" + twoDigits(sec);
};
export var millisecondToISODate = function (ms, timezone, format) {
    if (format === void 0) { format = DEFAULT_DATETIME_FORMAT; }
    if (ms === undefined || ms === null || isNaN(+ms)) {
        return '';
    }
    // if date format is not defined (undefined or null) use default format
    if (!format) {
        format = DEFAULT_DATETIME_FORMAT;
    }
    var dateMoment = moment(Number(ms));
    var dateMomentWithTimezone = timezone ? dateMoment.tz(timezone) : dateMoment;
    return dateMomentWithTimezone.format(format);
};
export var formatTwoDigits = function (n) { return (n > 9 ? n.toString() : "0" + n); };
export var timeAbbreviation = function (timeNumber, abbrev) {
    if (abbrev === void 0) { abbrev = ''; }
    if (timeNumber) {
        return "" + timeNumber + abbrev;
    }
    return null;
};
export var millisecondToLongDuration = function (ms) {
    var secondFromMs = 1000;
    var minutesFromMs = 60 * secondFromMs;
    var hoursFromMs = 60 * minutesFromMs;
    var daysFromMs = 24 * hoursFromMs;
    var monthFromMs = 30 * daysFromMs;
    var yearsFromMs = 12 * monthFromMs;
    var years = Math.floor(ms / yearsFromMs);
    var yearsRem = ms % yearsFromMs;
    var months = Math.floor(yearsRem / monthFromMs);
    var monthsRem = yearsRem % monthFromMs;
    var days = Math.floor(monthsRem / daysFromMs);
    var daysRem = monthsRem % daysFromMs;
    var hours = Math.floor(daysRem / hoursFromMs);
    var hoursRem = daysRem % hoursFromMs;
    var minutes = Math.floor(hoursRem / minutesFromMs);
    var strings = [
        timeAbbreviation(years, 'y'),
        timeAbbreviation(months, 'm'),
        timeAbbreviation(days, 'd'),
    ];
    var ymd = strings.filter(function (i) { return i !== null; }).join(' ');
    var hhmm = formatTwoDigits(hours) + ":" + formatTwoDigits(minutes);
    if (ymd) {
        return ymd + " " + hhmm;
    }
    return hhmm;
};
export var getTrendResultClassName = function (trend, goal) {
    if (trend === undefined || goal === undefined || goal === null) {
        return '';
    }
    if (trend === 0) {
        return 'stable';
    }
    else if ((trend > 0 && goal === 100) || (trend < 0 && goal === 0)) {
        return 'passed';
    }
    return 'failed';
};
export var getResultClassName = function (resultStatus) {
    if (!resultStatus) {
        return 'none';
    }
    else if (resultStatus === 'FAILED_FORCED') {
        return 'failed';
    }
    else if (resultStatus === 'PASSED_FORCED') {
        return 'passed';
    }
    else {
        return resultStatus.toLowerCase();
    }
};
export var getClosestOverflowHiddenElm = function (element, overflowType) {
    if (overflowType === void 0) { overflowType = 'both'; }
    var result = null;
    while (!result && !!element) {
        if (overflowType === 'both' && element.style.overflow === 'hidden') {
            result = element;
        }
        else if (overflowType === 'x-axis' && element.style.overflowX === 'hidden') {
            result = element;
        }
        else if (overflowType === 'y-axis' && element.style.overflowY === 'hidden') {
            result = element;
        }
        element = element.parentElement;
    }
    return result;
};
var contextCache = {};
export var getTextWidth = function (text, element) {
    var font = window.getComputedStyle(element).font;
    if (!contextCache[font]) {
        contextCache[font] = document.createElement('canvas').getContext('2d');
        contextCache[font].font = font;
    }
    var metrics = contextCache[font].measureText(text);
    return metrics.width;
};
export var moveCursorToTheEnd = function (input) {
    input.focus();
    input.selectionStart = input.selectionEnd = input.value.length;
};
/**
 * Separates number with " " after every 3rd digit counting from the right. E.g. 3 251 123.1234
 * @param value
 */
export var formatNumber = function (value) {
    // fr-FR gives us desired format
    return new Intl.NumberFormat('fr-FR', { useGrouping: true, maximumFractionDigits: 9 })
        .format(value)
        .replace(',', '.');
};
//# sourceMappingURL=utils.js.map